import getAkamaiHeaderValue from './getAkamaiHeaderValue.js';
import getAkamaiCookie from './getAkamaiCookie.js';

/**
 * Akamai Header utility
 *
 * getZipCode
 * Will return zip code from Akamai cookie.
 * if zip code from cookie is empty, will return zip code from Akamai cookie.
 *
 */
const zipPattern = /\b(zip=)([0-9]{5})/gi;
export default function getAkamaiZipCode(requestHeader) {
  const akamaiCookie = getAkamaiCookie();
  if (akamaiCookie) {
    const decodedLocationData = decodeURI(akamaiCookie);
    const akamaiZip = decodedLocationData.split('|')[2];
    if (akamaiZip && akamaiZip.length === 5) {
      return akamaiZip;
    }
    return '';
  }
  return getAkamaiHeaderValue(requestHeader, zipPattern);
}